import { render, staticRenderFns } from "./name-manage.vue?vue&type=template&id=d6c68450&scoped=true&"
import script from "./name-manage.vue?vue&type=script&lang=js&"
export * from "./name-manage.vue?vue&type=script&lang=js&"
import style0 from "./name-manage.vue?vue&type=style&index=0&id=d6c68450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c68450",
  null
  
)

export default component.exports